export const TOOLCHAIN_SCENARIOS = [
  {
    name: 'Heat Planning',
    wiki_url:
      'https://citiwatts.github.io/wiki/learning-heat-planning/#download-heat-scenario-assessment-excel-tool',
    download_url: 'https://gitlab.com/hotmaps/toolchain_scenarios/',
    project: ['citiwatts'],
  },
  {
    name: 'Cool Planning',
    wiki_url: 'https://citiwatts.github.io/wiki/learning-cool-planning/',
    download_url: 'https://gitlab.com/hotmaps/toolchain_scenarios/',
    project: ['citiwatts'],
  },
  {
    name: 'Electric Vehicle Scenarios',
    wiki_url: 'https://citiwatts.github.io/wiki/learning-ev-mobility-scenarios/',
    download_url: 'https://gitlab.com/hotmaps/toolchain_scenarios/',
    project: ['citiwatts'],
  },
  {
    name: 'Energy System Analysis and Flexibility (EnergyPLAN CM)',
    wiki_url: 'https://citiwatts.github.io/wiki/learning-energyplan-cm/',
    download_url: 'https://gitlab.com/hotmaps/toolchain_scenarios/',
    project: ['citiwatts'],
  },
]
